(function()
{
	//Include classes
	var Application = include("springroll.Application");
	var BitmapText = include('PIXI.extras.BitmapText');
	var Debug = include("springroll.Debug", false);
	var DebugOptions = include("nature.DebugOptions");

	var FINAL_FRAME = 11;

	/**
	 * Mixin for the HighScoreMarker animation
	 * @class HighScoreMarker
	 */
	var HighScoreMarker = function()
	{
		var app = Application.instance;
		var config = app.config;

		this.gotoAndStop(FINAL_FRAME);

		var userHighScore = app.userHighScore;
		this.x = DebugOptions.markerX ?
			DebugOptions.markerX :
			userHighScore * config.params.distanceFactor;
		this.y = 534;

		var flowerScore = config.ui.score.flowerScore;
		var displayScore = DebugOptions.markerScore ?
			DebugOptions.markerScore :
			// Ensure userHighScore is a string
			'' + userHighScore;
		// Display the high score on the banner next to the flower0
		var scoreText = new BitmapText(displayScore, flowerScore.style);
		scoreText.setPivotToAlign = true;
		scoreText.x = flowerScore.x;
		scoreText.y = flowerScore.y;
		scoreText.updateText();
		this.addChild(scoreText);

		// Add the litle dark green FT next to the score 
		var flowerFT = config.ui.score.flowerFT;
		var ftText = new BitmapText('FT', flowerFT.style);
		ftText.setPivotToAlign = true;
		ftText.x = flowerFT.x;
		ftText.y = flowerFT.y;
		ftText.updateText();
		this.addChild(ftText);
	};

	//Prototype reference
	var p = HighScoreMarker.prototype;

	/**
	 * destroy and don't use after this
	 * @method destroy
	 */
	p.destroy = function()
	{
		this.removeChildren();
	};

	//Assign to namespace
	namespace("nature").HighScoreMarker = HighScoreMarker;
}());
